export const STORE_PURCHASE_SUCCESS_FALLBACK =
  'This item has been added to your Collection.';

export const STORE_BUY_IN_FLIGHT_MESSAGE = 'Purchase already in progress';

const asRecord = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;

let storeBuyInFlight = false;
let latestMyStoreFetchId: string | null = null;

export const tryClaimStoreBuy = (): boolean => {
  if (storeBuyInFlight) {
    return false;
  }
  storeBuyInFlight = true;
  return true;
};

export const releaseStoreBuy = (): void => {
  storeBuyInFlight = false;
};

export const rememberMyStoreFetchId = (requestId?: string): void => {
  if (typeof requestId === 'string' && requestId) {
    latestMyStoreFetchId = requestId;
  }
};

export const isCurrentMyStoreFetch = (requestId?: string): boolean => {
  if (!requestId || !latestMyStoreFetchId) {
    return true;
  }
  return requestId === latestMyStoreFetchId;
};

export const resetMyStorePurchaseForTests = (): void => {
  storeBuyInFlight = false;
  latestMyStoreFetchId = null;
};

export const getMyStoreRows = (item: unknown): any[] => {
  const record = asRecord(item);
  const rows = record?.store;
  return Array.isArray(rows) ? rows : [];
};

export const hasVisibleMyStore = (item: unknown): boolean =>
  getMyStoreRows(item).length > 0;

export const normalizeMyStorePurchasePayload = (
  payload: unknown
): Record<string, unknown> => {
  if (typeof payload === 'string') {
    return { data: payload };
  }
  return asRecord(payload) ?? {};
};

export const readMyStorePurchaseMessage = (
  payload: unknown,
  fallback: string
): string => {
  if (typeof payload === 'string' && payload.trim()) {
    return payload;
  }

  const record = normalizeMyStorePurchasePayload(payload);
  const nested = asRecord(record.data);
  const raw =
    (typeof record.data === 'string' ? record.data : '') ||
    (typeof record.message === 'string' ? record.message : '') ||
    (typeof record.error === 'string' ? record.error : '') ||
    (typeof nested?.message === 'string' ? nested.message : '') ||
    (typeof nested?.error === 'string' ? nested.error : '');

  return raw.trim() || fallback;
};

export const isRejectedStoreAction = (result: unknown): boolean => {
  const record = asRecord(result);
  if (!record) {
    return false;
  }
  if (record.meta && asRecord(record.meta)?.requestStatus === 'rejected') {
    return true;
  }
  return (
    record.type === 'rejected' ||
    (typeof record.type === 'string' && record.type.endsWith('/rejected'))
  );
};

export const isFailedStorePurchaseStatus = (payload: unknown): boolean => {
  const record = normalizeMyStorePurchasePayload(payload);
  if (Object.keys(record).length === 0) {
    return false;
  }
  if (record.success === false || record.error) {
    return true;
  }
  return typeof record.status === 'number' && record.status >= 400;
};
